import { render, staticRenderFns } from "./Shelved.vue?vue&type=template&id=2c8c804c&"
import script from "./Shelved.vue?vue&type=script&lang=js&"
export * from "./Shelved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports